<style src="./Cover.scss" lang="scss"></style>

<template lang="pug">
  .cover(
    :class='classList'
  )
    .cover__crop(
      v-if='cover'
      :class='Array.isArray(cover) ? "is-mosaic" : null'
    )
      img.cover__image(
        v-if='!Array.isArray(cover)'
        :src='typeof cover === "string" ? `${HOST_URL}${cover}` : `${HOST_URL}${cover.medium}`'
        loading='lazy'
        alt
      )
      img.cover__image(
        v-else
        v-for='image in cover'
        :src='`${HOST_URL}${image}`'
        loading='lazy'
        alt
      )
</template>

<script>
import { HOST_URL } from "@/constants";

export default {
  name: "Cover",
  inheritAttrs: false,
  props: {
    type: String,
    cover: [String, Object, Array]
  },
  data() {
    return {
      HOST_URL
    };
  },
  computed: {
    isMosaic() {
      return Array.isArray(this.cover) && this.cover.length;
    },
    hasImage() {
      return this.cover && this.cover.medium;
    },
    classList() {
      return {
        "no-image": !(this.hasImage || this.isMosaic),
        "is-artist": this.type ? this.type === "artist" : null
      };
    }
  }
};
</script>
